var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"weater"}},[_c('div',{ref:"weather",attrs:{"id":"he-plugin-simple"}}),_c('remote-script',{attrs:{"src":"https://widget.qweather.net/simple/static/js/he-simple-common.js?v=2.0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }